import { useEffect, useState } from 'react';
import CrossSell from './CrossSell';
import CustomerWinback from './CustomerWinback';
import Feedback from './Feedback';
import { Layout, Link, Page, Toast } from '@shopify/polaris';
import { fetchPhoneSettings } from '../../../redux/actions/crmOrders';
import { PLAN_OLD_FREE, PLAN_OLD_PRO } from '../../../constants/constants';
import ApprovalModal from '../../ShopifyApprovalModal/ApprovalModal';
import { clevertapEventPush, CT_EVENT_IDS } from "../../../utils/clevertapUtils";

const AutomatedPromotionalTemplates = (props : any) => {
  const [toast, setToast] = useState({ show: false, message: '' });
  const [errorToast, setErrorToast] = useState({ show: false, message: '' });
  const [phoneData, setPhoneData] = useState({
    countryCode: '',
    phone: '',
  });

  const [userId, setuserId] = useState<any | null>(null);
  let shop = JSON.parse(localStorage.getItem('shop') || '{}');

  useEffect(() => {
    if (shop && shop.userId) {
      setuserId(shop.userId);
      getPhoneData(shop.userId);
    }
    clevertapEventPush({
      eventId: CT_EVENT_IDS.AUTOMATED_PROMOTIONAL_TEMPLATES_PAGE_VIEWED,
      eventData: {},
    });
  }, []);

  const getPhoneData = (userId: string) => {
    fetchPhoneSettings(userId).then((res: any) => {
      if (res.status === 'success') {
        setPhoneData(res.settings);
      }
    });
  };

  const showToast = (message: string) => {
    setToast({ show: true, message: message });
  };

  const showErrorToast = (message: string) => {
    setErrorToast({ show: true, message: message });
  };

  const toastMarkup = toast.show ? (
    <Toast
      content={toast.message}
      onDismiss={() => {
        setToast({ show: false, message: '' });
      }}
    />
  ) : null;

  const errorToastMarkup = errorToast.show ? (
    <Toast
      error
      content={errorToast.message}
      onDismiss={() => {
        setErrorToast({ show: false, message: '' });
      }}
    />
  ) : null;
  const [showModal, setShowModal] = useState(false);

  const checkForApproval = () => {
    if ([PLAN_OLD_FREE, PLAN_OLD_PRO].includes(Number(shop.planId))) {
      setShowModal(true);
    } else {
      return true;
    }
  };

  return (
    <Page
      subtitle={
        'SuperLemon provides the ability to send automated messages to your customers. You can enable these messages based on various events from the following list:'
      }
      primaryAction={<button style={{ display: 'none' }}></button>}
    >
      {toastMarkup}
      {errorToastMarkup}
      <div className='mb-3'>
        <Layout>
          <CrossSell
            userId={userId}
            showToast={showToast}
            showErrorToast={showErrorToast}
            phoneData={phoneData}
            checkForApproval={checkForApproval}
            optinEnterpriseTemplates={props.optinEnterpriseTemplates}
          />
        </Layout>
      </div>

      <div className='Polaris-Page--divider'></div>

      <div className='mt-1 mb-3'>
        <Layout>
          <CustomerWinback
            userId={userId}
            showToast={showToast}
            showErrorToast={showErrorToast}
            phoneData={phoneData}
            checkForApproval={checkForApproval}
            optinEnterpriseTemplates={props.optinEnterpriseTemplates}
          />
        </Layout>
      </div>
      <div className='Polaris-Page--divider'></div>

      <div className='mt-1 mb-3'>
        <Layout>
          <Feedback
            userId={userId}
            showToast={showToast}
            showErrorToast={showErrorToast}
            phoneData={phoneData}
            checkForApproval={checkForApproval}
            optinEnterpriseTemplates={props.optinEnterpriseTemplates}
          />
        </Layout>
      </div>
      <p>
        To learn about the cost of sending automated messages, view{' '}
        <Link
          external={true}
          url='https://docs.google.com/spreadsheets/u/2/d/1GX6yTDK8imK0YuOFCkU-Lpa3nCFifuq_oaujFvQaiCE/edit?usp=sharing'
        >
          {'pricing chart'}
        </Link>
      </p>
      <Layout>
        <ApprovalModal
          showModal={showModal}
          setShowModal={setShowModal}
          feature={'Automated Promotional Messages'}
        />
      </Layout>
    </Page>
  );
};
export default AutomatedPromotionalTemplates;
